
import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { UserProgressData } from '@/hooks/useUserProgress';

interface ActivityFeedProps {
  recentProgress: UserProgressData[];
}

const ActivityFeed: React.FC<ActivityFeedProps> = ({ recentProgress }) => {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Recent Activity</CardTitle>
      </CardHeader>
      <CardContent>
        {recentProgress.length > 0 ? (
          <div className="space-y-3">
            {recentProgress.map((progress) => (
              <div key={progress.id} className="flex items-center justify-between p-3 rounded-lg border">
                <div>
                  <p className="font-medium">Node {progress.node_id.slice(0, 8)}...</p>
                  <p className="text-sm text-black">
                    {progress.last_accessed_at ? 
                      new Date(progress.last_accessed_at).toLocaleDateString() :
                      'Recently accessed'
                    }
                  </p>
                </div>
                <div className="flex items-center gap-2">
                  <Badge variant={progress.status === 'completed' ? 'default' : 'outline'}>
                    {progress.status}
                  </Badge>
                  {progress.time_spent_seconds && (
                    <Badge variant="outline" className="text-xs">
                      {Math.floor(progress.time_spent_seconds / 60)}m
                    </Badge>
                  )}
                </div>
              </div>
            ))}
          </div>
        ) : (
          <p className="text-black">No recent activity. Start exploring content to see your progress here!</p>
        )}
      </CardContent>
    </Card>
  );
};

export default ActivityFeed;
